import axios from "axios";
import { FETCH_ALL_SIZE_API } from "../Constants/Apis";

export const getSizes = async () => {
  try {
    return axios.get(FETCH_ALL_SIZE_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createSize = async (payload) => {
  try {
    return axios.post(FETCH_ALL_SIZE_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateSize = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_SIZE_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteSize = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_SIZE_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

